import { render, staticRenderFns } from "./AlarmTrend.vue?vue&type=template&id=2bbfe4d7&scoped=true&"
import script from "./AlarmTrend.vue?vue&type=script&lang=js&"
export * from "./AlarmTrend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbfe4d7",
  null
  
)

export default component.exports